import React, { useState, useEffect } from 'react'
import messages from './messages'
import { FormattedMessage } from 'react-intl'
import { Full as Loading } from 'components/Loading'
import Icon from 'components/Icon'
import WhatsAppChat from './WhatsAppChat'

const PublicWhatsAppReplyPage = ({ match }) => {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [data, setData] = useState(null)
  const [sending, setSending] = useState(false)
  const token = match.params.token

  useEffect(() => {
    if (!token) {
      setError('No token provided')
      setLoading(false)
      return
    }

    fetch(`/rest/v2/whatsappreply/${token}`)
      .then((response) => response.json())
      .then(({ data, success, errors }) => {
        if (!success) {
          setError(errors?.join(', ') || 'Failed to load conversation')
          setLoading(false)
          return
        }

        setData(data)

        setLoading(false)
      })
      .catch((error) => {
        setError(error.message || 'Failed to load conversation')
        setLoading(false)
      })
  }, [token])

  const handleSend = (message) => {
    setSending(true)

    fetch(`/rest/v2/whatsappreply/${token}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams({
        message: message,
      }),
    })
      .then((response) => response.json())
      .then(({ success, errors }) => {
        setSending(false)

        if (!success) {
          toastr.error(errors?.join(', ') || 'Failed to send message')
          return
        }

        toastr.success('Message sent successfully!')
      })
      .catch((error) => {
        setSending(false)
        toastr.error(error.message || 'Failed to send message')
      })
  }

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#e5ddd5' }}>
        <Loading />
      </div>
    )
  }

  if (error || !data) {
    return (
      <div className="min-h-screen flex items-center justify-center p-4" style={{ backgroundColor: '#e5ddd5' }}>
        <div className="bg-white rounded-2xl shadow-2xl p-8 md:p-12 text-center w-full max-w-md border border-gray-100">
          <div className="mb-6">
          <Icon icon={['fas', 'comment-times']} className="text-4xl text-gray-400" />
          </div>
          <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">
            <FormattedMessage {...messages.conversationNotFound} />
          </h1>
          <p className="text-gray-600 text-sm md:text-base">{error || 'Unknown error'}</p>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-0 md:p-6" style={{ backgroundColor: '#e5ddd5' }}>
      <div className="w-full h-screen md:h-auto md:max-w-3xl md:rounded-lg bg-white shadow-2xl overflow-hidden flex flex-col">
        <div className="text-white px-4 md:px-5 py-3 md:py-4" style={{ backgroundColor: '#128c7e' }}>
          <h1 className="text-base md:text-lg font-semibold">
            <FormattedMessage {...messages.title} />
          </h1>
          {data.order && (
            <p className="text-xs md:text-sm opacity-90">
              {data.order.name}
            </p>
          )}
        </div>
        <div className="flex-1 overflow-hidden" style={{ backgroundColor: '#e5ddd5', minHeight: 0 }}>
          <div className="relative w-full h-full">
            <WhatsAppChat messages={data.messages || []} onSend={handleSend} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default PublicWhatsAppReplyPage
